// extracted by mini-css-extract-plugin
export default {"callBtn":"AdminMobileOrderStorePhoneNo_callBtn__qgUrC","callIcon":"AdminMobileOrderStorePhoneNo_callIcon__oI1QE"};